export const FREIGHT_MODE_LABELS: Record<string, string> = {
  CIF: '0 — Por conta do Emitente (CIF)',
  FOB: '1 — Por conta do Destinatário (FOB)',
  TERCEIROS: '2 — Terceiros',
  PROPRIO_REMETENTE: '3 — Próprio (Remetente)',
  PROPRIO_DESTINATARIO: '4 — Próprio (Destinatário)',
  SEM_FRETE: '9 — Sem Frete',
}

export const FREIGHT_MODE_KEYS = Object.keys(FREIGHT_MODE_LABELS)

export const freightModeLabel = (name?: string | null): string =>
  (name && FREIGHT_MODE_LABELS[name.trim().toUpperCase()]) || (name ?? '')

export const isFreightModeCanonical = (name?: string | null): boolean =>
  !!name && Object.prototype.hasOwnProperty.call(FREIGHT_MODE_LABELS, name.trim().toUpperCase())
